import { FOLDER_DIRECTORIES } from '../../constants/folder';
import { PAGINATION_LIMIT } from '../../utils/get-pagination-limit';
import { postFolderMaterialsQuery } from './get-folder-materials';

export type FolderMaterialCounts = Record<number, number>;

const chunk = <T>(items: T[], size: number): T[][] =>
    Array.from({ length: Math.ceil(items.length / size) }, (_, index) =>
        items.slice(index * size, index * size + size)
    );

const fetchCountsChunk = async (directory: FOLDER_DIRECTORIES, folderIds: number[]): Promise<FolderMaterialCounts> => {
    const queryBody = folderIds
        .map(
            (folderId) => `
            folder_${folderId}: folders_materials (
                filter: { folder_id: ${folderId}, folders__type: ${directory} }
                pagination: { limit: 1 }
            ) {
                material_id
                _total
            }
        `
        )
        .join('\n');

    const query = `
        query {
            ${queryBody}
        }
    `;

    return postFolderMaterialsQuery(directory, query).then(({ data }) => {
        const result: FolderMaterialCounts = {};

        folderIds.forEach((folderId) => {
            const list = data[`folder_${folderId}`] || [];

            result[folderId] = list[0]?._total ?? 0;
        });

        return result;
    });
};

export const getFolderMaterialCounts = async (
    directory: FOLDER_DIRECTORIES,
    folderIds: number[]
): Promise<FolderMaterialCounts> => {
    if (!folderIds.length) {
        return Promise.resolve({});
    }

    const chunks = chunk(folderIds, PAGINATION_LIMIT);

    return Promise.all(chunks.map((idsChunk) => fetchCountsChunk(directory, idsChunk))).then((results) =>
        results.reduce((merged, chunkResult) => ({ ...merged, ...chunkResult }), {} as FolderMaterialCounts)
    );
};
